import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import { InvisibleReCaptchaComponent } from 'ngx-captcha';

declare var hljs: any;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'invisible-recaptcha',
  templateUrl: './shared-recaptcha.html',
  standalone: false
})
export class SharedRecaptcha implements AfterViewInit, OnChanges {

  public readonly siteKey = environment.recaptchaV2InvisibleSiteKey;

  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaResponse?: string;
  public captchaIsReady = false;

  @Input() badge: 'bottomright' | 'bottomleft' | 'inline' = 'bottomright';
  public type: 'image' | 'audio';
  @Input() public theme: 'light' | 'dark' = 'light';
  @Input() public reloadRecaptcha: number;

  public recaptcha: any = null;

  @ViewChild('captchaElem', { static: false }) captchaElem: InvisibleReCaptchaComponent;
  @ViewChild('langInput', { static: false }) langInput: ElementRef;

  @Output() public recaptchaEvent = new EventEmitter();

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngAfterViewInit(): void {
    this.captchaIsLoaded = true;
    this.cdr.detectChanges();
    this.highlight();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.reloadRecaptcha) {
      this.reload();
    }
  }

  execute(): void {
    this.captchaElem.execute();
  }

  handleReset(): void {
    this.captchaSuccess = false;
    this.captchaResponse = undefined;
    this.cdr.detectChanges();
  }

  handleSuccess(captchaResponse: string): void {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
    this.recaptchaEvent.emit(this.captchaResponse);
    this.cdr.detectChanges();
  }

  handleLoad(): void {
    this.captchaIsLoaded = true;
    setTimeout(() => {
      this.execute();
    }, 1000);
    this.cdr.detectChanges();
  }

  handleReady(): void {
    this.captchaIsReady = true;
    this.cdr.detectChanges();
  }

  changeBadge(badge: 'bottomright' | 'bottomleft' | 'inline' = 'bottomright'): void {
    this.badge = badge;
  }

  changeType(type: 'image' | 'audio'): void {
    this.type = type;
  }

  getResponse(): void {
    const response = this.captchaElem.getResponse();
    if (!response) {
      alert(`There is no response from grecaptcha script - try using 'getCurrentResponse' method or subscribe to 'success' event`);
    } else {
      alert(response);
    }
  }

  handleError() {
    setTimeout(() => {
      this.reload();
    }, 1000);
  }

  reload(): void {
    if (this.captchaElem) {
      this.captchaElem.reloadCaptcha();
    }
  }

  getCaptchaId(): void {
    alert(this.captchaElem.getCaptchaId());
  }

  reset(): void {
    this.captchaElem.resetCaptcha();
  }

  getCurrentResponse(): void {
    const currentResponse = this.captchaElem.getCurrentResponse();
    if (!currentResponse) {
      alert('There is no current response - have you submitted captcha?');
    } else {
      alert(currentResponse);
    }
  }

  changeTheme(theme: 'light' | 'dark'): void {
    this.theme = theme;
  }

  private highlight(): void {
    const highlightBlocks = document.getElementsByTagName('code');
    for (let i = 0; i < highlightBlocks.length; i++) {
      const block = highlightBlocks[i];
      hljs.highlightBlock(block);
    }
  }
}
